// extracted by mini-css-extract-plugin
module.exports = {"cdo-price-section":"CellCdo_cdo-price-section__X76OL"};